import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const CsmRequestsList = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: 'async-requests-list' */ './csm-requests-list'),
	),
});
